import Link from 'next/link'
import tw from 'twin.macro'
import Paragraph from '../Paragraph'
import type { TFlavourButtonProps } from './interface'
import { activeStyles, hoverStyles, selectedStyles } from './styles'

const FlavourButton = (props: TFlavourButtonProps) => {
  const { title, link, children, ariaLabel, selected, onClick } = props

  return (
    <Link onClick={onClick} href={link} aria-label={ariaLabel} passHref>
      <div css={[tw`flex flex-row items-center focus:outline-none`, hoverStyles, activeStyles]}>
        <div
          css={[
            tw`rounded-full w-12 h-12 bg-white/30 flex items-center justify-center transition duration-300`,
            selected && selectedStyles,
          ]}
        >
          {children}
        </div>
        <Paragraph as="p" variant="footnote" tw="transition duration-300 opacity-0">
          {title}
        </Paragraph>
      </div>
    </Link>
  )
}

export default FlavourButton
